document.addEventListener('DOMContentLoaded', function(event) {
    KEYBOARD_FOCUS_ONLY();
    ADD_TAB_INDEX();
    multiLevelHover();
    initMegamenuImageLoader();
    videoUtils.checkAutoplayVideos();
});

// Initialize lazy loading of megamenu images
function initMegamenuImageLoader() {
  const topLevelMenuItems = document.querySelectorAll("#mainNav > li:not(:first-child)");
  // set up mutation observer watch for attribute changes in main menu items
  const observerConfig = { attributes: true };
  topLevelMenuItems.forEach(function(menuItem) {
    const imagesToLoad = menuItem.querySelector('img.not-loaded');
    if (imagesToLoad) {
      const observer = new MutationObserver(loadMegamenuImages);
      observer.observe(menuItem, observerConfig);
    }
  });
}

// Mutation observer callback to handle lazy loading of megamenu images
function loadMegamenuImages(mutationList, observer) {
  for (const mutation of mutationList) {
    // check it's an attribute change
    if (mutation.type === 'attributes') {
      const menuItem = mutation.target;
      // check if menu panel is open, classes over and hover are added for hover over and keyboard triggering
      if (menuItem.classList.contains('over') || menuItem.classList.contains('hover')) {
        // if it is then load any images in the panel that are not loaded
        let images = menuItem.querySelectorAll('img.not-loaded');
        for (const image of images ) {
          image.src = image.dataset.src;
          image.classList.remove('not-loaded');
        }
        // remove observer so that it doesn't fire on subsequent interactions
        observer.disconnect();
      }
    }
  }
}



window.addEventListener('load', (event) => {
  // check for URL hash
  const parsedUrl = new URL(window.location.href);
  if (parsedUrl.hash  ) {
    // check there is a target element, and if so use timeout to correct positioning
    let target = document.querySelector(`${parsedUrl.hash}`);
    if (target) {
      navUtils.scrollAfterTimeout(parsedUrl.hash);
    }
  }
});

const EE = document.querySelector('.sc-editor-mode');
if (!EE) {
    //floor plan item
    const SLIDER_LIGHTBOX = document.querySelectorAll('.simple-slider-wrapper');
    const FLOOR_ITEM = document.querySelector('.floor-plan-item');
    if (FLOOR_ITEM) {
        SLIDER_LIGHTBOX.forEach((item) => {
            const SLIDE_IMAGE = item.querySelectorAll('.floor-plan-item');
            SLIDE_IMAGE.forEach((img) => {
                img.setAttribute('tabindex', 0);
                img.addEventListener('keyup', function(event) {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        img.click();
                    }
                });
            });
            lightGallery(item, {
                selector: '.floor-plan-item',
                mode: 'lg-slide',
                zoom: true,
                getCaptionFromTitleOrAlt: true,
                download: false,
                share: false,
                subHtmlSelectorRelative: true,
            });
        });
    }
}

if (EE) {
    const SEARCH_BAR_EE = document.querySelector('.item .search-bar');
    const MAIN_EE = document.querySelector('.content-main');
    const QM = document.querySelector('.quick-menu-component form');
    if (SEARCH_BAR_EE) {
        let SEARCH_BAR_EE_HEIGHT = SEARCH_BAR_EE.offsetHeight;
        MAIN_EE.style.paddingTop = SEARCH_BAR_EE_HEIGHT - 1 + 'px';
    }
    if (QM) {
        QM.addEventListener('submit', function() {
            event.preventDefault();
        });
    }
}

// add focus outlines when User is using keyboard navigation
const KEYBOARD_FOCUS_ONLY = (e) => {
    document.addEventListener('keyup', function(e) {
        if (e.code === 'Tab') {
            document.body.classList.add('focus-outlines');
        }
        if (e.code === 'ArrowUp') {
          document.body.classList.add('focus-outlines');
        }
        if (e.code === 'ArrowDown') {
            document.body.classList.add('focus-outlines');
        }
    });
    document.addEventListener('click', function(e) {
        document.body.classList.remove('focus-outlines');
    });
};
const sliderNavPrev = document.querySelectorAll('.prev');
const sliderNavNext = document.querySelectorAll('.next');
//add tab index for focus outline
const ADD_TAB_INDEX = function() {
    const IFRAME = document.querySelectorAll('.media-content');
    const CONTROLS = document.querySelectorAll('.controls');
    const ACTIVE_ITEM = document.querySelectorAll('.tns-slide-active > a');
    const SLIDER_WRAPPER = document.querySelector('.main-slider-wrapper');
    const ACCORDION_PANEL = document.querySelectorAll('.desktop-panel-item');
    const GALLERY_IMG = document.querySelectorAll('.gallery-item');
    const IMG_NO_TAB = document.querySelectorAll('#propertyoptionupgradesbuyingliving .media-content');
    const MENU_IMAGE_ITEM_WRAP = document.querySelectorAll('.menu--item');

    const ON_ENTER_KEY = (element) => {
      if (event.keyCode === 13) {
          event.preventDefault();
          element.click();
      }
    };
    if (MENU_IMAGE_ITEM_WRAP) {
        MENU_IMAGE_ITEM_WRAP.forEach((menuItm) => {
            menuItm.addEventListener('keyup', function(event) {
                let linkTo = menuItm.querySelector('a');
                if (event.keyCode === 13) {
                    linkTo.click();
                }
            });
        });
    }

    if (SLIDER_WRAPPER) {
        SLIDER_WRAPPER.tabIndex = -1;
    }
    if (GALLERY_IMG) {
        GALLERY_IMG.forEach(function(GALLERY_IMG) {
            GALLERY_IMG.tabIndex = 0;
            GALLERY_IMG.addEventListener('keyup', function(event) {
                if (event.keyCode === 13) {
                    GALLERY_IMG.click();
                }
            });
        });
    }
    if (ACCORDION_PANEL) {
        ACCORDION_PANEL.forEach(function(ACCORDION_PANEL) {
            ACCORDION_PANEL.tabIndex = 0;
            ACCORDION_PANEL.addEventListener('keyup', function(event) {
                ON_ENTER_KEY(ACCORDION_PANEL);
            });
        });
    }
    if (ACTIVE_ITEM) {
        ACTIVE_ITEM.forEach(function(ACTIVE_ITEM) {
            ACTIVE_ITEM.tabIndex = 0;
        });
    }
    if (CONTROLS) {
        CONTROLS.forEach(function(CONTROLS) {
            CONTROLS.tabIndex = -1;
        });
    }
    if (sliderNavPrev) {
        sliderNavPrev.forEach((sliderNavPrev) => {
            sliderNavPrev.setAttribute('tabindex', 0);
            sliderNavPrev.addEventListener('keyup', function(event) {
                ON_ENTER_KEY(sliderNavPrev);
            });
        });
    }
    if (sliderNavNext) {
        sliderNavNext.forEach((sliderNavNext) => {
            sliderNavNext.setAttribute('tabindex', 0);
            sliderNavNext.addEventListener('keyup', function(event) {
                ON_ENTER_KEY(sliderNavNext);
            });
        });
    }

    if (IFRAME) {
        IFRAME.forEach(function(IFRAME) {
            IFRAME.setAttribute('tabindex', 0);
        });
    }

    if (IMG_NO_TAB) {
        IMG_NO_TAB.forEach(function(IMG_NO_TAB) {
            IMG_NO_TAB.tabIndex = -1;
        });
    }

};

const MHP_SUB_MENU = document.querySelector('.myhome-menu--wrap');
if (MHP_SUB_MENU) {
    MHP_SUB_MENU.style.top = document.querySelector('.header-component').getBoundingClientRect().height + 'px';
}

// function for scroll down to next section (Development Description) button (for use in gallery tinyslider component - assumes it is used on a Development page)
const scrollIntoViewButton = document.querySelector('.slide-down');
if (scrollIntoViewButton) {
    scrollIntoViewButton.addEventListener('click', () => {
      const developmentDescriptionWrapper = document.querySelector('.overlap-container').nextElementSibling;

      // we now work out the scroll margin position for the development description, performed by
      // adding the height of the header and submenu (we discount the breadcrumb as it doesn't
      // scroll down with the rest of the page) but we do add the Development sub-menu if it's open
      let devMenuHeight = 0;
      const devMenu = document.querySelector(".submenu-component");
      if ( devMenu ) {
        devMenuHeight = devMenu.getBoundingClientRect().height;
      }

      let devSubmenuHeight = 0;
      const devSubmenu = document.getElementById('submenuNav');
      if ( devSubmenu ) {
        devSubmenuHeight = devSubmenu.getBoundingClientRect().height;
      }
      let scrollMargin = document.querySelector(".header-component").clientHeight + Math.floor( devMenuHeight + devSubmenuHeight );
      developmentDescriptionWrapper.style.scrollMarginTop = `${scrollMargin}px`;

      // container has margin-top set to -5px (unknown as to why, perhaps concerning bordering?)
      developmentDescriptionWrapper.style.marginTop = 0;
      developmentDescriptionWrapper.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
}

const createFadeAnimationStylerule = function(index, itemId, animationDuration) {
  return `#${itemId}.tns-item {
                    left: 0;
                    animation-duration: ${animationDuration}s;
                    animation-name: transition${index};
                    animation-iteration-count: infinite;
                  }`;
};

const createOpacityKeyframe = function(step, opacity ) {
  let suffix = '';
  if ( !( step === 'to' || step === 'from') ) {
    suffix = '%';
  }

  return `
      ${step}${suffix} {
        opacity: ${opacity};
      }
    `;
};

const createFadeAnimationKeyframes = function(index, itemId, animationDuration, transitionDuration, itemCount) {
  let frames = [];
  let numIntermediateTransitions = itemCount - 1;
  let displayIntervalPercentage = 100 / itemCount;
  let transitionPercentage = 100 * (transitionDuration / 2) / animationDuration;

  // create the from step
  // first/last slides fade in/out
  let initialOpacity = 0;
  if ( index === 0 ) {
    initialOpacity = 1;
  }
  frames.push(createOpacityKeyframe('from', initialOpacity));

  // loop over the intermediate transitions
  for (let i = 1; i <= numIntermediateTransitions; i++) {
    if ( i === index ) {
      frames.push(createOpacityKeyframe((i * displayIntervalPercentage) - transitionPercentage, 0));
      frames.push(createOpacityKeyframe((i * displayIntervalPercentage), 1));
    } else if ( i === index + 1 ) {
      frames.push(createOpacityKeyframe((i * displayIntervalPercentage) - transitionPercentage, 1));
      frames.push(createOpacityKeyframe((i * displayIntervalPercentage), 0));
    }
  }

  // set transition end on first and last
  if ( index === 0 ) {
    frames.push(createOpacityKeyframe(100 - transitionPercentage, 0));
    frames.push(createOpacityKeyframe('to', 1));
  } else if ( index === itemCount - 1) {
    frames.push(createOpacityKeyframe(100 - transitionPercentage, 1));
    frames.push(createOpacityKeyframe('to', 0));
  } else {
    frames.push(createOpacityKeyframe('to', 0));
  }

  return `@keyframes transition${index} {
    ${frames.join('')}
  }`;

};

const setHeroHeight = () => {
    let hero = document.querySelector('.image-carousel-component[data-slider-mode="gallery"]') || document.querySelector('.fullscreen-video-component');
    // we need to work out height of hero image, so bottom is aligned with bottom of viewable window
    // so we must calculate the height of the UI above the hero to correctly work this out.

    // check for presence of berkeley banner component
    let bannerHeight = 0;
    let breadcrumbOffsetHeight = 0;
    let breadcrumbContainer = document.querySelector('.breadcrumbs-container');
    if (breadcrumbContainer) {
      breadcrumbOffsetHeight = breadcrumbContainer.offsetHeight;
    }
    const banner = document.querySelector('aside.__berkeley-banner');
    if ( banner ) {
        bannerHeight = banner.offsetHeight;
    }
    let offset = document.querySelector(".header-component").offsetHeight + bannerHeight +
        breadcrumbOffsetHeight +
        document.querySelector(".submenu-component").offsetHeight;
    // now set the height of the carousel and images to window height subtracting total height of earlier elements
    // currently need to remove one pixel to resolve rounding issues caused by use of offsetHeight on elements which
    // have fractional values to start with
    let heroHeight = window.innerHeight - (offset-1);
    hero.style.height = heroHeight + "px";
    let heroSlider = hero.querySelector('.main-slider-wrapper') || hero.querySelector('video.page-movie');
    if ( heroSlider ) {
      heroSlider.style.height = heroHeight + "px";
    }
    hero.style.overflow = 'hidden';
};

const resetHeroHeight = () => {
  if (window.scrollY === 0) {
    setHeroHeight();
  }
};

const fullScreenHero = document.querySelector('.image-carousel-component[data-slider-mode="gallery"]') || document.querySelector('.fullscreen-video-component');
if (fullScreenHero) {
  window.addEventListener("load", () => {
    setHeroHeight();
    window.addEventListener("resize", resetHeroHeight, {passive: true});
    windowUtils.addOrientationListener(resetHeroHeight);
  });
}

const mainHeroSliderInit = function() {
  const imageCarouselComponents = document.querySelectorAll('.image-carousel-component'); // container above slider
  imageCarouselComponents.forEach((imageCarouselComponent) => {
      const mainSliderWrapper = imageCarouselComponent.querySelector('.main-slider-wrapper'); // container with slider
      const mainHeroCaption = imageCarouselComponent.querySelector('.hero-caption-container');
      const sliderItemCount = mainSliderWrapper.childElementCount;
      // is this instance of the slider using gallery mode?
      const sliderMode = imageCarouselComponent.getAttribute('data-slider-mode');
      if (sliderMode === 'gallery') {
          // Get the interval for transitions, default to 5s
          let transitonInterval = 5000;
          if ( imageCarouselComponent.hasAttribute('data-transition-duration') ) {
            transitonInterval = imageCarouselComponent.getAttribute('data-transition-duration');
          }
          //  transition duration, set to 1s
          let transitonDuration = 1000;

          // If there are more than one item then set up the transitions
          if (sliderItemCount > 1) {
              let createdHtml = false;
              let initSlider = () => {
                if (!createdHtml) {
                  let items = mainSliderWrapper.querySelectorAll('.tns-item');
                  let style = document.createElement("style");
                  document.head.appendChild(style);
                  // TNS clones one image, so ignore that
                  let cloned = mainSliderWrapper.querySelectorAll('.tns-slide-cloned');
                  let itemCount = items.length - cloned.length;
                  let animationDurationSec = (itemCount * transitonInterval / 1000);
                  let transitionDurationSec = transitonDuration / 1000;

                  const createItemAnimation = ( item, index ) => {
                    if ( item.id !== '' ) {
                      // tidy up the TNS slider animation
                      item.classList.remove('tns-normal');
                      item.classList.remove('tns-fadeIn');

                      let stylerule = createFadeAnimationStylerule(index, item.id, animationDurationSec);
                      style.sheet.insertRule(stylerule, 0);

                      stylerule = createFadeAnimationKeyframes(index, item.id, animationDurationSec, transitionDurationSec, itemCount );
                      style.sheet.insertRule(stylerule, 0);
                    }
                  };

                  items.forEach(createItemAnimation);

                  createdHtml = true;
                }
              };

              // Create TNS slider so that we can use the classes and layout, but the fade in/out is performed by the animations above
              const heroSlider = tns({
                  mode: 'gallery', // fade in and out
                  controls: false, // hide controls
                  container: mainSliderWrapper,
                  autoplay: false, // turn on autoplay
                  autoplayButtonOutput: false,
                  nav: false,
                  navAsThumbnails: false,
                  onInit: initSlider
              });
          }
      } else {
          // normal carousel mode - the following code is unchanged from before
          const controlsContainer = imageCarouselComponent.querySelector('.controls');
          if (sliderItemCount > 1) {
              controlsContainer.style.display = 'block';
              const heroSlider = tns({
                  container: mainSliderWrapper,
                  items: 1,
                  slideBy: '1',
                  preventScrollOnTouch: 'auto',
                  autoplay: false,
                  autoplayButtonOutput: false,
                  autoplayResetOnVisibility: false,
                  mouseDrag: true,
                  nav: false,
                  autoHeight: true,
                  navAsThumbnails: true,
                  controlsContainer: controlsContainer,
              });
              let refreshSliderInsideTab = (e) => {
                  heroSlider.refresh();
              };
              Array.from(document.getElementsByClassName('tablinks'), (btn) =>
                  btn.addEventListener('click', refreshSliderInsideTab, false)
              );
          }
      }
      if (mainHeroCaption && (mainHeroCaption.childElementCount > 0)) {
        const mainHeroCaptionButton = mainHeroCaption.querySelector('.hero-caption-button');
        const mainHeroCaptionText = mainHeroCaption.querySelector('.hero-caption-text');
        mainHeroCaptionButton.addEventListener("click", () => {
            mainHeroCaptionText.classList.toggle("expanded");
            if (mainHeroCaptionText.classList.contains("expanded")) {
                mainHeroCaptionButton.setAttribute("aria-expanded", "true");
            } else {
                mainHeroCaptionButton.setAttribute("aria-expanded", "false");
            }
        });

        mainHeroCaptionText.addEventListener("transitionend", () => {
          if (mainHeroCaptionText.classList.contains("expanded")) {
            mainHeroCaptionText.firstElementChild.focus();
          }
        });
      }
  });
};
if (document.querySelectorAll('.image-carousel-component')) {
  mainHeroSliderInit();
}

const cardComponentSliderInit = function() {
    const cardComponent = document.querySelectorAll('.card-component'); // container above slider
    cardComponent.forEach(function(sliderWrapper) {
        const slider = sliderWrapper.querySelector('.card-component-wrapper'); // container with slider
        const controlsContainer = sliderWrapper.querySelector('.controls');
        const thumbWrapperCount = slider.childElementCount;
        if (thumbWrapperCount > 4 || screen.width < 991) {
            controlsContainer.style.display = 'block';
            const thumbSlider = tns({
                items: 4,
                slideBy: '1',
                container: slider,
                autoplay: false,
                navContainer: true,
                preventScrollOnTouch: 'auto',
                touch: true,
                mouseDrag: true,
                nav: false,
                navAsThumbnails: true,
                controlsContainer: controlsContainer,
                responsive: {
                    320: {
                        items: 1,
                        slideBy: '1',
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                    },
                    900: {
                        items: 4,
                        slideBy: '1',
                        mouseDrag: true,
                    },
                },
            });
        }
    });
};
if (document.querySelectorAll('.card-component')) {
    cardComponentSliderInit();
}
const downloadComponentSliderInit = function() {
    const downloadComponent = document.querySelectorAll('.download-component'); // container above slider
    downloadComponent.forEach(function(sliderWrapper) {
        const slider = sliderWrapper.querySelector('.download-item-wrapper'); // container with slider
        const controlsContainer = sliderWrapper.querySelector('.controls');
        const downloadWrapperCount = slider.childElementCount;
        if (downloadWrapperCount > 4 || screen.width < 991) {
            controlsContainer.style.display = 'block';
            const thumbSlider = tns({
                items: 4,
                slideBy: '1',
                container: slider,
                autoplay: false,
                navContainer: true,
                preventScrollOnTouch: 'auto',
                touch: true,
                mouseDrag: true,
                nav: false,
                navAsThumbnails: true,
                controlsContainer: controlsContainer,
                responsive: {
                    320: {
                        items: 1,
                        slideBy: '1',
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                    },
                    900: {
                        items: 4,
                        slideBy: '1',
                        mouseDrag: true,
                    },
                },
            });
        }
    });
};
if (document.querySelectorAll('.download-component')) {
    downloadComponentSliderInit();
}
const gridSliderMobile = function() {
    const mainGridSlider = document.querySelectorAll('.columns-mobile-slider'); // container above slider
    mainGridSlider.forEach(function(sliderWrapper) {
        const slider = sliderWrapper.querySelector('.grid'); // container with slider
        const controlsContainer = sliderWrapper.querySelector('.controls');
        const sliderWrapperCount = slider.childElementCount;
        if (sliderWrapperCount > 1 && screen.width < 1025) {
            controlsContainer.style.display = 'block';
            const gridSlider = tns({
                container: slider,
                items: 1,
                slideBy: '1',
                preventScrollOnTouch: 'auto',
                autoplay: false,
                autoplayButtonOutput: false,
                autoplayResetOnVisibility: false,
                mouseDrag: true,
                loop: false,
                nav: false,
                navAsThumbnails: true,
                controlsContainer: controlsContainer,
            });
        }
    });
};
if (document.querySelectorAll('.grid')) {
    gridSliderMobile();
}
const descriptionCalloutSliderInit = function() {
    const descriptionCalloutComp = document.querySelectorAll('.description-callout-component');
    descriptionCalloutComp.forEach(function(descWrapper) {
        const slider = descWrapper.querySelector('.description-callout-wrapper');
        const controlsContainer = descWrapper.querySelector('.controls');
        const thumbSlider = tns({
            container: slider,
            items: 1,
            slideBy: '1',
            autoplay: false,
            navContainer: true,
            preventScrollOnTouch: 'auto',
            mouseDrag: true,
            nav: false,
            navAsThumbnails: true,
            controlsContainer: controlsContainer,
            responsive: {
                320: {
                    disable: false,
                    controls: true
                },
                1400: {
                    disable: true,
                    controls: false
                }
            },
        });
    });
};
if (document.querySelectorAll('.description-callout-component')) {
    descriptionCalloutSliderInit();
}
const simpleSliderInit = function() {
    const SIMPLE_SLIDER_COMPONENT = document.querySelectorAll('.simple-slider-component');
    SIMPLE_SLIDER_COMPONENT.forEach(function(sliderWrapper) {
        let ITEMS_DISPLAYED_VALUE = sliderWrapper.getAttribute('data-items-to-be-displayed');
        let ITEMS_SLIDE_BY_VALUE = sliderWrapper.getAttribute('data-items-to-be-slideby');
        const slider = sliderWrapper.querySelector('.simple-slider-component > div'); // container with slider
        const controlsContainer = sliderWrapper.querySelector('.controls');
        const sliderWrapperCount = slider.childElementCount;
        let thumbSlider = tns({
            items: ITEMS_DISPLAYED_VALUE,
            slideBy: ITEMS_SLIDE_BY_VALUE,
            container: slider,
            autoplay: false,
            navContainer: true,
            preventScrollOnTouch: 'auto',
            touch: true,
            mouseDrag: true,
            swipeAngle: 30,
            nav: false,
            loop: false,
            navAsThumbnails: true,
            controlsContainer: controlsContainer,
            responsive: {
                320: {
                    items: 1,
                    slideBy: '1',
                    preventScrollOnTouch: 'auto',
                },
                900: {
                    items: 1,
                    slideBy: 1,
                },
                990: {
                    items: 1,
                    slideBy: 1,
                },
                1023: {
                    items: 1,
                    slideBy: 1,
                },
                1025: {
                    items: 1,
                    slideBy: 1,
                },
                1100: {
                    items: 1,
                    slideBy: 1,
                },
                1192: {
                    items: ITEMS_DISPLAYED_VALUE,
                    slideBy: ITEMS_SLIDE_BY_VALUE,
                },
            },
        });
    });
};
if (document.querySelectorAll('.simple-slider-component')) {
    simpleSliderInit();
}

// page error return to previous page
const RETURN_BTN = document.querySelector('.return-link');
if (RETURN_BTN) {
    RETURN_BTN.addEventListener('click', function(e) {
        e.preventDefault();
        history.go(-1);
    });
}

/// MAIN NAVIGATION MOBILE START
//Add login link to mobile navigation
const LOGIN_BUTTON = document.getElementById('myHomeLink');
const NAVIGATION_PLACEHOLDER = document.querySelector('.mp-menu ul');

if (LOGIN_BUTTON) {
    const LOGIN_LINK = LOGIN_BUTTON.href;
    const LOGIN_TITLE = LOGIN_BUTTON.title;
    const LOGIN_DESCRIPTION = LOGIN_BUTTON.getAttribute('data-desc');
    let navLink = `<li class="mp-border"><a href="${LOGIN_LINK}" title="${LOGIN_TITLE}"><i class="icon-user"></i>${LOGIN_DESCRIPTION}</a></li>`;
    NAVIGATION_PLACEHOLDER.innerHTML += navLink;
}
//Add myhome menu items to mobile navigation
const MY_HOME_WRAPPER = document.querySelector('.myhome-menu--wrap');
if (MY_HOME_WRAPPER) {
    const LOGOUT = document.getElementById('myHomeLogout');
    const HELP_BTN = document.getElementById('myHomePlusHelp');
    const LANGUAGE_SELECTOR = document.querySelector('.language-selector-component');
    const MY_HOME_ITEMS = document.querySelectorAll('.myhome-menu li');
    let myHomeMenuItem;

    const addHelpBtnLastItem = () => {
        if (i >= MY_HOME_ITEMS.length - 1) {
            if (HELP_BTN) {
                let itemURL = HELP_BTN.href;
                let itemTxt = HELP_BTN.textContent;
                let itemTitle = HELP_BTN.title;
                let itemHelp = `<li><a href="${itemURL}" ` + (itemTitle.length > 0 ? `title="${itemTitle}"` : `` ) + `>${itemTxt}</a></li>`;
                NAVIGATION_PLACEHOLDER.insertAdjacentHTML('afterbegin', itemHelp);
            }
        }
    };

    for (var i = MY_HOME_ITEMS.length - 1; i >= 0; i--) {
        let item = MY_HOME_ITEMS[i].querySelector('a');
        if (item) {
            let counter = item.querySelector('.myhome-menu--counter');
            let counterTxt = counter !== null ? counter.textContent : '';
            let itemURL = item.href;
            let itemTxt = item.childNodes[2].nodeValue;
            let itemTitle = item.title;
            myHomeMenuItem = `<li><a href="${itemURL}" title="${itemTitle}">${itemTxt} ${
              counter ? `<span class="myhome-menu--counter">${counterTxt}</span>` : ''
            }</a></li>`;

            addHelpBtnLastItem();

            NAVIGATION_PLACEHOLDER.insertAdjacentHTML('afterbegin', myHomeMenuItem);
        } else {
          // messages for notifications
          let messageMenu = MY_HOME_ITEMS[i].firstElementChild;
          if (messageMenu && messageMenu.hasAttribute('data-modal')) {
            myHomeMenuItem = `<li><button type="button" data-modal="${messageMenu.getAttribute('data-modal')}"
                        title="${messageMenu.getAttribute('title')}"
                        class="${messageMenu.getAttribute('class')}">
                        ${messageMenu.getAttribute('title')}
                        <span class="counter myhome-menu--counter">${messageMenu.querySelector('.counter').innerText}</span>
                        </button></li>`;

                        addHelpBtnLastItem();

            NAVIGATION_PLACEHOLDER.insertAdjacentHTML('afterbegin', myHomeMenuItem);
          }
        }
    }

    if (LOGOUT) {
        let itemURL = LOGOUT.href;
        let itemTxt = LOGOUT.textContent;
        let itemTitle = LOGOUT.title;
        let itemClass = LOGOUT.className;
        let item = `<li class="mp-button"><a class="${itemClass}" href="${itemURL}" ` + (itemTitle.length > 0 ? `title="${itemTitle}"` : `` ) + `>${itemTxt}</a></li>`;
        NAVIGATION_PLACEHOLDER.insertAdjacentHTML('afterbegin', item);
    }

    if (LANGUAGE_SELECTOR) {
        let language_btn = LANGUAGE_SELECTOR.querySelectorAll('.flag-item');
        language_btn.forEach((btn) => {
            let language_icon = btn.querySelectorAll('img');
            language_icon.forEach((lang_img) => {
                let btnUrl = btn.href;
                let btnTitle = btn.title;
                let btnClass = btn.className;
                let btnLan = `<li class="mp-button flag-button"><a class="${btnClass}" href="${btnUrl}" title="${btnTitle}">
                    <img src="${lang_img.src}" alt="${lang_img.alt}">
                </a></li>`;
                NAVIGATION_PLACEHOLDER.insertAdjacentHTML('afterbegin', btnLan);
            });
        });
    }
}
///MAIN NAVIGATION MOBILE END


//calculate sitecore header
const SITECORE_NAVIGATION = document.querySelector('.container-narrow');
const NAV_HEADER = document.querySelector('.header-component');
if (SITECORE_NAVIGATION) {
  let elHeight = SITECORE_NAVIGATION.offsetHeight;
  NAV_HEADER.style.marginTop = elHeight + 'px';
  NAV_HEADER.style.position = 'relative';
}

//Search bar
const searchTrigger = document.getElementById('searchTrigger');
if (searchTrigger) {
  let navigationSearchField = document.getElementById('navigationSearchBox');
  let triggerParent = searchTrigger.parentNode;
  searchTrigger.addEventListener('click', () => {
    new Promise(resolve => {
      triggerParent.classList.toggle('open');
      resolve();
    }).then(() => {
      // ensure search input field has focus to prevent user from having to click inside field to perform search
      if (triggerParent.classList.contains('open')) {
        navigationSearchField.focus();
      } else {
        searchTrigger.blur();
      }
    });
    if (screen.width < 768) {
      let bodyTag = document.querySelector('body');
      if (triggerParent.classList.contains('open')) {
        bodyTag.classList.add('scroll-disable');
      } else {
        bodyTag.classList.remove('scroll-disable');
      }
    }
  });
}

//preventing MacOS based browsers from submitting the property search form when Enter is pressed on any of the dropdowns
const propertySearchDropdowns = document.querySelectorAll('select.form-field');
//detect Safari browser (we have to discount Chrome, as both values can appear in Chrome and Edge browsers on Macs)
const detectSafari = ((navigator.userAgent.indexOf('Safari') !== -1) && navigator.userAgent.indexOf('Chrome') === -1);
if (propertySearchDropdowns && detectSafari) {
    propertySearchDropdowns.forEach((propertySearchDropdown) => {
        propertySearchDropdown.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        });
    });
}

// check for travel timeline component
const travelTimelines = document.querySelectorAll('.travel-timeline');
if (travelTimelines.length) {
  // check if the floodfill filter exists already
  const filterElement = document.getElementById('travel-timeline-floodfill-color');
  if (!filterElement) {
    // if not add it at the end of the body
    const floodFilter = '<svg width="0" height="0"><defs><filter id="travel-timeline-floodfill-color"><feFlood flood-color="var(--travel-timeline-theme-color)" flood-opacity="1" /><feComposite in2="SourceAlpha" operator="in" /></filter></defs></svg>';
    const body = document.querySelector('body');
    body.insertAdjacentHTML('afterbegin', floodFilter);
  }
  // check for timeline colour field
  const travelTimelineTheme = document.querySelector('.travel-timeline-theme');
  const travelTimelineAltTheme = document.querySelector('.main-theme');
  if (travelTimelineTheme) {
    // if it exists then set the timeline there colour
    const timelineColor = travelTimelineTheme.dataset.travelTimelineThemeColor;
    document.documentElement.style.setProperty('--travel-timeline-theme-color', timelineColor);
  } else if (travelTimelineAltTheme) {
    // else if there is a theme colour set then use it
    const timelineColor = travelTimelineAltTheme.dataset.themeColor;
    document.documentElement.style.setProperty('--travel-timeline-theme-color', timelineColor);
  }
}


//Print iframe
function printIframe() {
  var frame = document.getElementById('ExternalWebContentExternalIFrame');
  var val = frame.getAttribute('src');
  var iframeWindow = window.open(val, '_blank', 'width=800,height=650,scrollbars=1,menuBar=1');
  return iframeWindow;
}

//Resize iframe
if (document.getElementById('ExternalWebContentExternalIFrame')) {
  iFrameResize({ log: true }, '#ExternalWebContentExternalIFrame');
}

const SHARE_BTN = document.querySelectorAll('.copy-url');
if (SHARE_BTN) {
  SHARE_BTN.forEach((sharBtn) => {
    sharBtn.classList.remove('simple-social-share');
    sharBtn.addEventListener('click', function copy(that) {
      const inp = document.createElement('input');
      document.body.appendChild(inp);
      inp.value = window.location;
      inp.select();
      document.execCommand('copy', false);
      inp.remove();
    });
  });
}

//check orientation change and hide dropDown
function checkHideDropdown() {
  //extra check for mobile navigation
  if(document.getElementById('trigger').classList.contains('open')){
    document.getElementById('trigger').click();
  }
  const dropdownAnchor = document.getElementById('dropDown');
  if(dropdownAnchor){
    dropdownAnchor.blur();
  }
}
window.addEventListener("load", () => {
  if (document.getElementById('dropDown')) {
    windowUtils.addOrientationListener(checkHideDropdown);
  }
});

//logic for buying-process
if (!EE) {
  const TAB_COMPONENT_BUYING = document.querySelectorAll('.tab-component-buying');
  if (TAB_COMPONENT_BUYING) {
    TAB_COMPONENT_BUYING.forEach((tabComp) => {
      const TAB_ITEM_LINK_BUYING = tabComp.querySelector('.tab-buying-link');
      const TAB_CONTENT_WRAPPER_BUYING = tabComp.querySelector('.tab-buying-wrapper');
      //make first tab and content visible on page load
      if (TAB_ITEM_LINK_BUYING && TAB_CONTENT_WRAPPER_BUYING) {
        window.addEventListener('load', () => {
          const activeTabBuying = tabComp.querySelector('.tab-buying-link .tablinks.active');
          setActiveTabBuying(activeTabBuying);
        });
      }

      //handle tab functionality on click for every tab item
      let handleClickBuying = (e) => {
        setActiveTabBuying(e.target);
      };
      let setActiveTabBuying = function(target) {
        Array.from(document.querySelectorAll('.tab-buying-link .tablinks.active'), (e) => {
          e.classList.remove('active');
        }); // remove `active` class from btn tabs.
        Array.from(document.querySelectorAll('.tab-buying-wrapper .tab-buying-content.active'), (e) => {
          e.classList.remove('active');
        }); // remove `active` class from tab contents.
        let tabElement;
        if (!target.classList.length) {
          tabElement = target.parentElement.parentNode;
        } else {
          if (target.classList.contains('tablinks')) {
            tabElement = target;
          } else {
            tabElement = target.parentNode;
          }
        }
        tabElement.classList.add('active');
        document.querySelector(`div.tab-buying-content[data-id*="${tabElement.dataset.id}"]`).classList.add('active');

      };

      Array.from(document.querySelectorAll('.tab-buying-link .tablinks'), (btn) =>
        btn.addEventListener('click', handleClickBuying, false)
      );
    });
  }
}

//init social sharing on click
const SOCIAL_SHARE_COMPONENT = document.querySelectorAll('.social-share-component');
if (SOCIAL_SHARE_COMPONENT) {
  SOCIAL_SHARE_COMPONENT.forEach((socialComp) => {
    const SOCIAL_SHARE_BTNS = socialComp.querySelectorAll('.simple-social-share');
    SOCIAL_SHARE_BTNS.forEach((socialBtns) => {
      socialBtns.addEventListener('click', function socialShare(event) {
        event.preventDefault();
        return simpleJSSocialShare.go(this);
      });
    });
  });
}



const MOBILE_SEARCH_FILTERS = document.querySelector('.search-bar--filters');
if (MOBILE_SEARCH_FILTERS) {
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('filters--trigger')) {
      MOBILE_SEARCH_FILTERS.classList.toggle('open');
      if (screen.width < 768) {
        let bodyTag = document.querySelector('body');
        if (MOBILE_SEARCH_FILTERS.classList.contains('open')) {
          bodyTag.classList.add('scroll-disable');
        } else {
          bodyTag.classList.remove('scroll-disable');
        }
      }
    }
  });
}

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

//Close thank you message after form submit
document.addEventListener('click', function (e) {
  if (e.target.classList.contains('close--button') && e.target.parentNode.classList.contains('thank-you--message')) {
    e.target.parentNode.remove();
  }
});

// Check if page has a Register Interest form
let registerInterestForm = document.getElementById('register-interest-form');
if (registerInterestForm) {
  document.querySelectorAll('a[href="#register-interest-form"]').forEach((anchor) => {
    if (!anchor.classList.contains('quick-menu-button')) {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        navUtils.scrollToWithCorrection(this.getAttribute('href'), anchor);
      });
    }
  });
}


// Quick Menu Component
const QUICK_COMPONENT = document.querySelector('.quick-menu-component');
if (QUICK_COMPONENT) {
  QUICK_COMPONENT.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      navUtils.scrollToWithCorrection(this.getAttribute('href'), anchor);
    });
  });
}

let isTouch = 'ontouchstart' in window;
document.documentElement.className += isTouch ? ' touch ' : ' no-touch ';
